<ng-template #rt let-r="result" let-t="term">
  {{ r.name }}
</ng-template>
<label for="">{{ label }}</label>
<div class="input-group flex-nowrap input-group-sm">
  <span class="input-group-text" id="addon-wrapping"
    ><i class="fa fa-search" aria-hidden="true"></i
  ></span>
  <input
    [id]="id"
    [(ngModel)]="selectedItem"
    type="text"
    class="form-control"
    [ngbTypeahead]="search"
    [inputFormatter]="formatter"
    [resultTemplate]="rt"
    [focusFirst]="false"
    (focus)="focus$.next($any($event).target.value)"
    (click)="click$.next($any($event).target.value)"
    (selectItem)="emitSelected($event)"
    #instance="ngbTypeahead"
    [editable]="false"
    (blur)="onBlurHandler($event)"
    placeholder="{{ label }}"
    [disabled]="disabled"
  />
</div>
